// Client mirrors of server route gates (Gitea #94). Each predicate answers
// "will this endpoint accept this user?" with exactly the server's check, so
// the client never sends a request it knows will be refused with 403.
// `user` is the AuthContext user ({ role, permissions }). Keep each predicate
// in step with the server line cited beside it — if the server gate changes,
// change it here too.

const flag = (user, key) => user?.permissions?.[key] === true;
const BUILT_IN_ADMIN_ROLES = ['admin', 'payroll_admin', 'program_admin'];

// server/middleware/auth.js requireAdmin: program_admin, or the Manage users
// permission. Guards GET /api/tenant-settings (tenantSettings.js) and every
// /api/zoho/* route (zoho.js, e.g. GET /status).
export const passesRequireAdmin = (user) =>
  user?.role === 'program_admin' || flag(user, 'can_manage_users');

// server/routes/invoices.js GET / — requirePermission('can_manage_invoices').
export const canListInvoices = (user) =>
  user?.role === 'program_admin' || flag(user, 'can_manage_invoices');

// server/routes/dashboard.js GET /admin-inbox — ADMIN_FAMILY role names, or
// any of MANAGERIAL_PERMS.
export const ADMIN_INBOX_PERMISSIONS = Object.freeze([
  'can_approve_time', 'can_approve_pto', 'can_approve_expenses',
  'can_manage_invoices', 'can_run_payroll', 'can_run_reports',
]);
export const canReadAdminInbox = (user) =>
  BUILT_IN_ADMIN_ROLES.includes(user?.role) || ADMIN_INBOX_PERMISSIONS.some((k) => flag(user, k));

// server/routes/search.js GET / (⌘K data search) — built-in role names only.
export const canUseGlobalSearch = (user) => BUILT_IN_ADMIN_ROLES.includes(user?.role);

// server/middleware/auth.js hasTenantTaxAccess (plan 122, Gitea #170): every
// /api/payroll/tax-filings* and /api/tax-deposits* route. Built-in admin roles
// by name, otherwise Access tax forms together with Run payroll.
export const canAccessTenantTaxForms = (user) =>
  BUILT_IN_ADMIN_ROLES.includes(user?.role)
  || (flag(user, 'can_access_tax_forms') && flag(user, 'can_run_payroll'));
